<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true"
    custom-class="list-dialog">
    <el-table
      :data="supplylist"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        label="单号" prop="erpserial"
        align="left" width="180px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="右眼" prop="R"
        align="left" width="100px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="左眼" prop="L"
        align="left" width="100px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="供应商单号" prop="DMSPlusNumber"
        align="left" width="200px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="跟踪号" prop="TrackingNumber"
        align="left" width="130px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="快递单号" prop="ExpressCode"
        align="left" width="140px"
        header-align="center" >
      </el-table-column>
      <el-table-column
        label="状态" prop="status"
        align="left"
        header-align="center" >
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
    import {getEssilorBackinfo} from '@/api/ossi';

    export default {
      name: "BuyfromListEssilor",
      data() {
        return {
          title: '订单信息',
          dialogSeeVisible: false,
          supplylist: []
        }
      },
      methods: {
        show(erpserial) {
          this.supplylist = []
          this.dialogSeeVisible = true
          getEssilorBackinfo({erpserial: erpserial}).then(resCus => {
            var data = resCus.data.obj;
            for(let i in data) {
              var row = {}
              var postdata = JSON.parse(data[i].posttxt);
              var backdata = data[i].backtxt ? JSON.parse(data[i].backtxt) : {};
              console.log(backdata)
              row.erpserial = postdata.Head.SourceReference;
              for (let j in postdata.Items) {
                var itemEx = postdata.Items[j].ItemExtend;
                if (itemEx.Eye == 'Right') {
                  row.R = itemEx.Sphere + ' / ' + itemEx.Cylinder;
                } else {
                  row.L = itemEx.Sphere + ' / ' + itemEx.Cylinder;
                }
              }
              row.DMSPlusNumber = backdata.DMSPlusNumber;
              row.TrackingNumber = backdata.TrackingNumber;
              row.ExpressCode = backdata.ExpressCode;
              row.status='';
              if(backdata.Flags) {
                var flags = JSON.parse(backdata.Flags);
                if (flags.length > 0) {
                  var fg = flags[flags.length - 1];
                  row.status = fg.FlagDateTime + ' ' + fg.FlagDescription;
                }
              }
              this.supplylist.push(row);
            }
          });
        },
      },
      mounted() {
      },
      components: {}
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromListEssilor.vue